import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

axiosInstance.interceptors.request.use((config) => {
  const raw = localStorage.getItem('authToken');
  const token = raw ? JSON.parse(raw) : null;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => response, // Forward successful responses
  (error) => {
    if (error.response && error.response.status === 401) {
      // Handle token expiry or unauthorized access
      localStorage.clear(); // Custom function to log out the user
    }
    return Promise.reject(error);
  }
);

// Axios service object
const ApiService = {
  // Function to perform GET request
  get: async (url, config = {}) => {
    try {
      const response = await axiosInstance.get(url, config);
      return response.data;
    } catch (error) {
      handleRequestError(error);
    }
  },

  // Function to perform POST request
  post: async (url, data, config = {}) => {
    try {

      const response = await axiosInstance.post(url, data, config);
      return response.data;
    } catch (error) {
      handleRequestError(error);
    }
  },

  // Function to perform PUT request
  put: async (url, data, config = {}) => {
    try {
      const response = await axiosInstance.put(url, data, config);
      return response.data;
    } catch (error) {
      handleRequestError(error);
    }
  },

  // Function to perform PATCH request
  patch: async (url, data = {}, config = {}) => {
    try {
      const response = await axiosInstance.patch(url, data, config);
      return response.data;
    } catch (error) {
      handleRequestError(error);
    }
  },

  // Function to perform DELETE request
  delete: async (url, config = {}) => {
    try {
      const response = await axiosInstance.delete(url, config);
      return response.data;
    } catch (error) {
      handleRequestError(error);
    }
  },
};

// Function to handle request errors
const handleRequestError = (error) => {
  console.error('Request error:', error);
  throw error;
};

export default ApiService;







